// extracted by mini-css-extract-plugin
module.exports = {"container":"e_5o","textBadge":"e_6o","buttonBlock":"e_7o"};